import * as api from '../../../clients/api';

import {Action} from '@ngrx/store';

export const POST_LOGUT = '[ApiModul] PostLogut laden';
export const POST_LOGUT_AUSFUEHREN = '[ApiModul] PostLogut ausführen';
export const POST_LOGUT_ERFOLGREICH = '[ApiModul] PostLogut laden erfolgreich';
export const POST_LOGUT_FEHLER = '[ApiModul] PostLogut Ladefehler';
export const POST_LOGUT_NICHT_AUSGEFUEHRT = '[ApiModul] PostLogut nicht ausgeführt (evtl. Offline)';


export class PostLogutAction implements Action {
    readonly type = POST_LOGUT;
        constructor(public logoutRequest: api.LogoutRequest, public optPayload: any = null) {}
    }
export class PostLogutAusfuehrenAction implements Action {
    readonly type = POST_LOGUT_AUSFUEHREN;
        constructor(public logoutRequest: api.LogoutRequest, public optPayload: any = null) {}
    }
export class PostLogutErfolgreichAction implements Action {
    readonly type = POST_LOGUT_ERFOLGREICH;
        constructor(public payload: api.LogoutResult, public logoutRequest: api.LogoutRequest, public optPayload: any = null) {}
    }
export class PostLogutFehlerAction implements Action {
    readonly type = POST_LOGUT_FEHLER;
        constructor(public payload: any, public logoutRequest: api.LogoutRequest, public optPayload: any = null) {}
    }
export class PostLogutNichtAusgefuehrtAction implements Action {
    readonly type = POST_LOGUT_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type ApiCommandLogutActions =
    PostLogutAction
    | PostLogutAusfuehrenAction
    | PostLogutErfolgreichAction
    | PostLogutFehlerAction
    | PostLogutNichtAusgefuehrtAction
    ;
